module.exports = __webpack_public_path__ + "img/icon_chexiao2.5d0aef4e.svg";